export function formatToCEP(cep) {
  if (cep == null || cep == undefined) return cep;
  // Remove any non-numeric characters
  cep = cep.replace(/\D/g, '');
  // Format the CEP as XXXXX-XXX
  return cep.replace(/^(\d{5})(\d{3})$/, '$1-$2');
}

export function formatToCNPJ(cnpj) {
  if (cnpj == null || cnpj == undefined) return cnpj;
  // Remove any non-numeric characters
  cnpj = cnpj.replace(/\D/g, '');
  // Format the CNPJ as XX.XXX.XXX/XXXX-XX
  return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}

export function formatPhoneOrCelphone(input) {
  if (input == null || input == undefined) return input;

  let valor = input.replace(/\D/g, ''); // Remove tudo que não for número

  if (valor.length > 10) {
    // Máscara para celular com DDD (11 dígitos)
    valor = valor.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
  } else if (valor.length > 6) {
    // Máscara para telefone fixo com DDD (10 dígitos)
    valor = valor.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
  } else {
    // Máscara parcial enquanto o usuário digita
    valor = valor.replace(/^(\d{0,2})(\d{0,4})(\d{0,4})$/, function (_, p1, p2, p3) {
      return `${p1 ? '(' + p1 : ''}${p2 ? ') ' + p2 : ''}${p3 ? '-' + p3 : ''}`;
    });
  }
  return valor;
}

export function formatToPercentage(num) {
  if (!Number.isFinite(num)) return 0;
  const decimalPart = num.toString().split('.')[1];
  //return `${(decimal * 100).toFixed(2)}%`;
  return decimalPart && decimalPart.length > 2 ? `${num.toFixed(2)}%` : `${num}%`;
}

export function formatToCurrency(value, currency = 'BRL') {
  if (value == null) return null;

  const number = Number(value);
  const amount = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: currency,
  }).format(number);

  if (Number(amount) < 1) {
    return;
  }

  return amount;
}


export function removeHTMLTags(text){
  return text.replace(/<[^>]+>/g, "");
}